import { SensorListInfo } from 'emr-ng-shared';

export class UpdateShipment {
    trackerId: string;;
    sensorRange: string;
    SensorTempRangeId: number;
    SensorCO2RangeId: number;
}

